import React from "react";

type Props = {
  query: string;
  setQuery: (q: string) => void;
  categories: string[];
  filterType: string;
  setFilterType: (t: string) => void;
  sortBy: string;
  setSortBy: (s: string) => void;
  viewGrid: boolean;
  setViewGrid: (v: boolean) => void;
};

const ResourceFilters: React.FC<Props> = ({
  query,
  setQuery,
  categories,
  filterType,
  setFilterType,
  sortBy,
  setSortBy,
  viewGrid,
  setViewGrid,
}) => {
  return (
    <div className="bg-white p-4 rounded-md shadow-sm flex flex-col md:flex-row gap-3 items-center">
      <div className="flex-1">
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search resources by title or description..."
          className="w-full border rounded-md px-3 py-2 text-sm"
        />
      </div>

      <div className="flex items-center gap-2">
        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          className="border rounded-md px-2 py-2 text-sm"
        >
          {categories.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="border rounded-md px-2 py-2 text-sm"
        >
          <option value="most_downloaded">Most Downloaded</option>
          <option value="latest">Latest</option>
          <option value="az">A — Z</option>
        </select>

        <div className="flex items-center border rounded-md overflow-hidden">
          <button
            onClick={() => setViewGrid(true)}
            className={`px-3 py-2 ${viewGrid ? "bg-slate-100" : ""}`}
            aria-pressed={viewGrid}
          >
            Grid
          </button>
          <button
            onClick={() => setViewGrid(false)}
            className={`px-3 py-2 ${!viewGrid ? "bg-slate-100" : ""}`}
            aria-pressed={!viewGrid}
          >
            List
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResourceFilters;
